import { Outlet } from "react-router";
import { AppHeader } from "@/domains/general/components/appHeader";
import { AppSidebar } from "@/domains/general/components/appSidebar";

export function AppLayout(): React.JSX.Element {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <AppHeader />
      <div className="flex min-h-0 flex-1">
        <AppSidebar />
        <main className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="mx-auto max-w-7xl space-y-6 px-6 py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
